import { Injectable } from '@angular/core';
import { Observable, from } from 'rxjs';
import { map, take, mergeMap, toArray } from 'rxjs/operators';
import { ResourceLoadResponse } from './state';
import { User } from '../models/user';
import { AuthFacade } from '../auth/state/auth.facade';

@Injectable()
export abstract class BaseUtilitiesService<T> {
	constructor(private authFacade: AuthFacade) {

	}

	public mapArrayAsObservable(matches: ResourceLoadResponse<T>): Observable<ResourceLoadResponse<T>> {
		return this.authFacade.currentUser$.pipe(
			take(1),
			mergeMap(currentUser =>
				from(matches.results).pipe(
					mergeMap(item => this.map(item, currentUser)),
					toArray(),
					map(arr => ({
						total: matches.total,
						results: [...arr]
					} as ResourceLoadResponse<T>))
				),
			),
		);
	}

	public mapAsObservable(entity: T): Observable<T> {
		return this.authFacade.currentUser$.pipe(
			take(1),
			mergeMap(currentUser => this.map(entity, currentUser))
		);
	}

	public abstract map(match: T, currentUser: User): Observable<T>;
}
